import actionTypes from 'redux/actions/actionTypes'

const refenceMediaTypes = {
	image: 'Image',
	video: 'Video',
	audio: 'Audio',
	pdf: 'PDF',
	web: 'Web Content',
}
const refenceMediaSources = {
	audio_recorder: 'Audio Recorder',
	drive: 'Google Drive',
	dropbox: 'DropBox',
	google: 'Google Images',
	local: 'Local',
	onedrive: 'One Drive',
	web: 'Web Content',
	youtube: 'Youtube',
}

const ACTIVITY_TYPES = {
	[actionTypes.OEQ_UPLOAD_REFERENCE_MEDIA]: 'OEQ',
	[actionTypes.QUIZ_UPLOAD_REFERENCE_MEDIA]: 'Quiz',
	[actionTypes.POLL_UPLOAD_REFERENCE_MEDIA]: 'Poll',
	[actionTypes.DRAW_IT_UPLOAD_REFERENCE_MEDIA]: 'Draw It',
}

export default action => {
	const properties = {}
	properties['Reference Media Type'] = refenceMediaTypes[action.allowedTypes]
	properties['Reference Media Source'] = refenceMediaSources[action.files.files[0].type]
	if (properties['Reference Media Source'] === refenceMediaSources['audio_recorder'] ) {
		properties['Reference Media Type'] = properties['Reference Media Source']
	}
	properties['Activity'] = ACTIVITY_TYPES[action.type]
	return properties
}
